module.exports = __webpack_public_path__ + "static/media/arrow.04b3f18c.svg";